<template>
    <HomeLayout>
        <!-- HERO -->
        <section class="contact-hero">
            <div class="section-label">Get In Touch</div>
            <h1 class="section-title">We would love to <span>hear from you</span></h1>
            <p
                style="color:var(--text-mid);font-size:.95rem;max-width:480px;margin:0 auto;font-weight:300;line-height:1.7;">
                Whether you are looking for care, want to join our team, or are exploring a partnership, we are here to
                help.
            </p>
        </section>

        <!-- BODY -->
        <div class="contact-body">

            <!-- Form -->
            <div class="contact-form-wrap">
                <div id="contactForm">
                    <h3>Send us a message</h3>
                    <p>Fill in your details below and we will get back to you within one business day.</p>

                    <div class="form-row">
                        <div class="form-group">
                            <label>First Name <span class="required">*</span></label>
                            <input type="text" id="firstName" placeholder="e.g. Adaeze" required />
                        </div>
                        <div class="form-group">
                            <label>Last Name <span class="required">*</span></label>
                            <input type="text" id="lastName" placeholder="e.g. Okonkwo" required />
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Email Address <span class="required">*</span></label>
                        <input type="email" id="email" placeholder="you@example.com" required />
                    </div>

                    <div class="form-group">
                        <label>Phone Number</label>
                        <input type="tel" id="phone" placeholder="+234 800 000 0000" />
                    </div>

                    <div class="form-group">
                        <label>I am a <span class="required">*</span></label>
                        <select id="userType" required>
                            <option value="" disabled selected>Select who you are</option>
                            <option value="care-seeker">Care Seeker Looking for a Care Giver</option>
                            <option value="care-giver">Care Giver Looking for work</option>
                            <option value="investor">Investor Exploring a partnership</option>
                            <option value="other">Other</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Subject <span class="required">*</span></label>
                        <input type="text" id="subject" placeholder="How can we help?" required />
                    </div>

                    <div class="form-group">
                        <label>Message <span class="required">*</span></label>
                        <textarea id="message" placeholder="Tell us a little more..." required></textarea>
                    </div>

                    <p class="form-note"><span class="required">*</span> Required fields</p>

                    <button class="btn-submit" onclick="submitForm()">Send Message</button>
                </div>

                <!-- Success state -->
                <div class="form-success" id="formSuccess">
                    <div class="success-icon">✅</div>
                    <h4>Message sent!</h4>
                    <p>Thank you for reaching out. We will get back to you within one business day.<br>In the meantime,
                        feel free to chat with us on WhatsApp.</p>
                    <br>
                    <a href="https://wa.me/2349180002370" target="_blank" class="btn-green"
                        style="display:inline-block;margin-top:8px;">Chat with us</a>
                </div>
            </div>

        </div>

    </HomeLayout>
</template>

<script lang="js">
import HomeLayout from '../Layouts/HomeLayout.vue';
export default {
    name: "ContactUs",
    components: {
        HomeLayout,
    }
}
</script>

<style lang="css" scoped>
:root {
    --pink: #F59CAB;
    --pink-light: #FDE8EC;
    --pink-mid: #F8C4CC;
    --green: #17865F;
    --green-dark: #0f5c41;
    --green-light: #E8F5EF;
    --cream: #FDF9F7;
    --orange: #FF9700;
    --text-dark: #1C2B27;
    --text-mid: #4A5E58;
    --text-light: #8A9E98;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    font-family: 'Open Sans', sans-serif;
    background: var(--cream);
    color: var(--text-dark);
    overflow-x: hidden;
}

/* RIBBON */
.ribbon {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    background: var(--green);
    color: white;
    padding: 9px 20px;
    font-size: .84rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-shadow: 0 2px 12px rgba(23, 134, 95, .2);
}

.ribbon span {
    opacity: .88;
    font-weight: 300;
}

.ribbon a {
    background: white;
    color: var(--green);
    padding: 5px 16px;
    border-radius: 100px;
    font-weight: 700;
    font-size: .8rem;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: background .2s, color .2s;
}

.ribbon a:hover {
    background: var(--pink);
    color: white;
}


/* NAV */
nav {
    position: fixed;
    top: 38px;
    left: 0;
    right: 0;
    z-index: 900;
    background: rgba(253, 249, 247, .96);
    backdrop-filter: blur(14px);
    border-bottom: 1px solid rgba(245, 156, 171, .12);
    padding: 0 6%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.nav-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
}

.logo-text {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.35rem;
    font-weight: 700;
    color: var(--text-dark);
}

.logo-text sup {
    font-size: .5rem;
    color: var(--text-light);
    font-weight: 400;
}

.nav-links {
    display: flex;
    align-items: center;
    gap: 28px;
    list-style: none;
}

.nav-links a {
    font-size: .85rem;
    color: var(--text-mid);
    text-decoration: none;
    font-weight: 400;
    transition: color .2s;
}

.nav-links a:hover {
    color: var(--green);
}

.nav-ctas {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-ghost {
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    color: var(--text-mid);
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px 14px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 400;
    transition: color .2s;
}

.btn-ghost:hover {
    color: var(--green);
}

.btn-primary {
    font-family: 'Open Sans', sans-serif;
    font-size: .85rem;
    font-weight: 700;
    background: var(--pink);
    color: white;
    border: none;
    padding: 10px 22px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    transition: background .2s, transform .15s;
}

.btn-primary:hover {
    background: #e8849a;
    transform: translateY(-1px);
}

.btn-green {
    font-family: 'Open Sans', sans-serif;
    font-size: .9rem;
    font-weight: 700;
    background: var(--green);
    color: white;
    border: none;
    padding: 13px 32px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: background .2s, transform .15s;
}

.btn-green:hover {
    background: var(--green-dark);
    transform: translateY(-1px);
}

.btn-outline-green {
    font-family: 'Open Sans', sans-serif;
    font-size: .9rem;
    font-weight: 700;
    background: transparent;
    color: var(--green);
    border: 2px solid var(--green);
    padding: 11px 28px;
    border-radius: 100px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: background .2s, color .2s;
}

.btn-outline-green:hover {
    background: var(--green);
    color: white;
}

/* HERO */
.hero {
    min-height: 100vh;
    padding-top: 102px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    padding-left: 7%;
    padding-right: 0;
    overflow: hidden;
    background: var(--cream);
    position: relative;
}

.hero::before {
    content: '';
    position: absolute;
    top: 80px;
    right: 0;
    width: 52%;
    height: 88%;
    background: var(--pink-light);
    border-radius: 60px 0 0 60px;
    z-index: 0;
    opacity: .5;
}

.hero-content {
    position: relative;
    z-index: 2;
    padding: 60px 7% 32px;
}

.hero-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: var(--green-light);
    color: var(--green);
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    padding: 6px 14px;
    border-radius: 100px;
    margin-bottom: 22px;
}

.hero-eyebrow span {
    width: 6px;
    height: 6px;
    background: var(--green);
    border-radius: 50%;
}

.hero h1 {
    font-family: 'Lora', serif;
    font-size: clamp(2.4rem, 4.2vw, 3.6rem);
    font-weight: 400;
    line-height: 1.12;
    color: var(--text-dark);
    margin-bottom: 20px;
}

.hero h1 em {
    font-style: italic;
    color: var(--green);
}

.hero-sub {
    font-size: 1rem;
    color: var(--text-mid);
    line-height: 1.7;
    max-width: 450px;
    margin-bottom: 36px;
    font-weight: 300;
}

.hero-ctas {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
}

/* CAROUSEL */
.hero-visual {
    position: relative;
    height: 100vh;
    min-height: 500px;
    overflow: hidden;
    z-index: 1;
}

.hero-visual::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, var(--cream) 0%, transparent 18%);
    z-index: 2;
    pointer-events: none;
}

.carousel {
    width: 100%;
    height: 100%;
    position: relative;
}

.carousel-slides {
    display: flex;
    width: 100%;
    height: 100%;
    transition: transform .7s cubic-bezier(.4, 0, .2, 1);
}

.carousel-slide {
    min-width: 100%;
    height: 100%;
    position: relative;
    flex-shrink: 0;
}

.carousel-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
}

.carousel-dots {
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 10;
}

.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, .5);
    cursor: pointer;
    transition: background .3s, transform .3s;
    border: none;
    padding: 0;
}

.dot.active {
    background: white;
    transform: scale(1.3);
}

.carousel-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: rgba(255, 255, 255, .85);
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    font-size: .9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background .2s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .12);
}

.carousel-btn:hover {
    background: white;
}

.carousel-prev {
    left: 12px;
}

.carousel-next {
    right: 12px;
}

.hero-badge {
    position: absolute;
    bottom: 60px;
    left: -14px;
    z-index: 10;
    background: white;
    border-radius: 16px;
    padding: 14px 18px;
    box-shadow: 0 8px 28px rgba(0, 0, 0, .1);
    display: flex;
    align-items: center;
    gap: 11px;
    min-width: 205px;
}

.badge-icon {
    width: 36px;
    height: 36px;
    background: var(--green-light);
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.05rem;
    flex-shrink: 0;
}

.badge-text {
    font-size: .74rem;
    color: var(--text-mid);
}

.badge-text strong {
    display: block;
    font-size: .86rem;
    color: var(--text-dark);
    font-weight: 700;
    margin-bottom: 1px;
}

/* SECTION HELPERS */
.section-label {
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .12em;
    text-transform: uppercase;
    color: var(--pink);
    margin-bottom: 10px;
}

.section-title {
    font-family: 'Lora', serif;
    font-size: clamp(1.7rem, 2.8vw, 2.4rem);
    font-weight: 400;
    color: var(--text-dark);
    line-height: 1.2;
    margin-bottom: 12px;
}

.section-title em {
    font-style: italic;
    color: var(--green);
}

.section-sub {
    font-size: .95rem;
    color: var(--text-mid);
    max-width: 520px;
    line-height: 1.7;
    font-weight: 300;
    margin-bottom: 48px;
}

/* SERVICES */
.services {
    padding: 80px 7%;
    background: white;
}

.service-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

.service-card {
    background: var(--cream);
    border-radius: 20px;
    padding: 30px 26px;
    border: 1.5px solid transparent;
    transition: border-color .25s, transform .25s, box-shadow .25s;
    cursor: pointer;
}

.service-card:hover {
    border-color: var(--pink);
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(245, 156, 171, .14);
}

.service-icon {
    width: 58px;
    height: 58px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.75rem;
    margin-bottom: 18px;
    line-height: 1;
}

.service-card h3 {
    font-family: 'Lora', serif;
    font-size: 1.05rem;
    font-weight: 400;
    color: var(--text-dark);
    margin-bottom: 8px;
}

.service-card p {
    font-size: .82rem;
    color: var(--text-mid);
    line-height: 1.6;
    font-weight: 300;
}

.service-arrow {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: .78rem;
    color: var(--green);
    font-weight: 700;
    margin-top: 16px;
    text-decoration: none;
    transition: gap .2s;
}

.service-card:hover .service-arrow {
    gap: 9px;
}

/* HOW IT WORKS */
.how {
    padding: 90px 7%;
    background: var(--cream);
    text-align: center;
}

.how .section-sub {
    margin: 0 auto 56px;
}

.steps {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    position: relative;
}

.steps::before {
    content: '';
    position: absolute;
    top: 36px;
    left: 17%;
    right: 17%;
    height: 2px;
    background: linear-gradient(to right, var(--pink-mid), var(--green));
    z-index: 0;
}

.step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 0 28px;
    position: relative;
    z-index: 1;
}

.step-num {
    width: 72px;
    height: 72px;
    background: white;
    border: 2.5px solid var(--pink-mid);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Lora', serif;
    font-size: 1.4rem;
    font-weight: 400;
    color: var(--green);
    box-shadow: 0 4px 18px rgba(245, 156, 171, .2);
    transition: border-color .2s, background .2s;
}

.step:hover .step-num {
    border-color: var(--green);
    background: var(--green-light);
}

.step h3 {
    font-family: 'Lora', serif;
    font-size: 1.05rem;
    font-weight: 400;
    color: var(--text-dark);
}

.step p {
    font-size: .82rem;
    color: var(--text-mid);
    line-height: 1.65;
    font-weight: 300;
    max-width: 230px;
}

/* CAREGIVERS */
.caregivers {
    padding: 90px 7%;
    background: white;
}

.care-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 44px;
    flex-wrap: wrap;
    gap: 16px;
}

.cg-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
}

.cg-card {
    background: var(--cream);
    border-radius: 20px;
    overflow: hidden;
    transition: transform .25s, box-shadow .25s;
    cursor: pointer;
}

.cg-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 16px 40px rgba(0, 0, 0, .1);
}

.cg-photo {
    height: 220px;
    position: relative;
    overflow: hidden;
    background: var(--pink-light);
}

.cg-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
}

.cg-verified {
    position: absolute;
    top: 12px;
    right: 12px;
    background: var(--green);
    color: white;
    font-size: .68rem;
    font-weight: 700;
    padding: 3px 9px;
    border-radius: 100px;
    letter-spacing: .04em;
}

.cg-info {
    padding: 16px;
}

.cg-name {
    font-weight: 700;
    font-size: .95rem;
    color: var(--text-dark);
    margin-bottom: 2px;
}

.cg-role {
    font-size: .78rem;
    color: var(--text-mid);
    margin-bottom: 6px;
    font-weight: 300;
}

.cg-avail {
    font-size: .75rem;
    color: var(--green);
    display: flex;
    align-items: center;
    gap: 5px;
}

.avail-dot {
    width: 6px;
    height: 6px;
    background: var(--green);
    border-radius: 50%;
}

/* ── Caregiver card CTA buttons ── */
.cg-btn-row {
    display: flex;
    gap: 8px;
    margin-top: 14px;
}

.cg-btn-request,
.cg-btn-details {
    flex: 1;
    padding: 10px 8px;
    font-family: 'Open Sans', sans-serif;
    font-size: .78rem;
    font-weight: 700;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    transition: opacity .2s, transform .15s;
}

.cg-btn-request {
    background: var(--green);
    color: white;
}

.cg-btn-details {
    background: var(--pink);
    color: white;
}

.cg-btn-request:hover,
.cg-btn-details:hover {
    opacity: .88;
    transform: translateY(-1px);
}






/* WHY SUCCOUR */
.why {
    padding: 90px 7%;
    background: var(--cream);
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 56px;
    align-items: center;
}

.why-visual {
    position: relative;
    border-radius: 28px;
    overflow: hidden;
    height: 480px;
}

.why-visual img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.why-pill {
    position: absolute;
    bottom: 26px;
    left: 26px;
    background: white;
    border-radius: 14px;
    padding: 14px 18px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 8px 28px rgba(0, 0, 0, .1);
}

.why-pill-icon {
    width: 34px;
    height: 34px;
    background: var(--pink-light);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
}

.why-pill-text {
    font-size: .77rem;
    color: var(--text-mid);
}

.why-pill-text strong {
    display: block;
    font-size: .88rem;
    color: var(--text-dark);
    font-weight: 700;
}

.why-features {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 32px;
}

.why-feature {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 18px 20px;
    background: white;
    border-radius: 14px;
    border-left: 3px solid var(--pink);
    transition: border-color .2s, box-shadow .2s;
}

.why-feature:hover {
    border-color: var(--green);
    box-shadow: 0 4px 16px rgba(23, 134, 95, .08);
}

.why-feature-icon {
    width: 36px;
    height: 36px;
    background: var(--green-light);
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    flex-shrink: 0;
}

.why-feature h4 {
    font-size: .9rem;
    font-weight: 700;
    color: var(--text-dark);
    margin-bottom: 4px;
}

.why-feature p {
    font-size: .81rem;
    color: var(--text-mid);
    line-height: 1.6;
    font-weight: 300;
}

/* AUDIENCE */
.audience {
    padding: 90px 7%;
    background: white;
}

.audience-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
    margin-top: 50px;
}

.aud-card {
    border-radius: 24px;
    padding: 38px 30px;
    display: flex;
    flex-direction: column;
}

.aud-card.families {
    background: var(--pink-light);
}

.aud-card.caregivers-c {
    background: var(--green-light);
}

.aud-card.volunteers {
    background: #FFF3E0;
}

.aud-tag {
    font-size: .7rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    margin-bottom: 12px;
    opacity: .7;
}

.aud-card h3 {
    font-family: 'Lora', serif;
    font-size: 1.35rem;
    font-weight: 400;
    margin-bottom: 12px;
    line-height: 1.3;
}

.aud-card p {
    font-size: .83rem;
    color: var(--text-mid);
    line-height: 1.7;
    font-weight: 300;
    margin-bottom: 24px;
}

.aud-list {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 28px;
    flex-grow: 1;
}

.aud-cta-row {
    margin-top: 24px;
}

.aud-btn {
    display: block;
    width: 100%;
    padding: 13px 20px;
    border-radius: 100px;
    font-family: 'Open Sans', sans-serif;
    font-size: .88rem;
    font-weight: 700;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    border: none;
    box-sizing: border-box;
    transition: opacity .2s, transform .15s;
}

.aud-btn:hover {
    opacity: .88;
    transform: translateY(-1px);
}

.aud-btn-pink {
    background: var(--pink);
    color: white;
}

.aud-btn-green {
    background: var(--green);
    color: white;
}

.aud-btn-outline {
    background: transparent;
    color: var(--green);
    border: 2px solid var(--green);
}

.aud-list li {
    font-size: .81rem;
    color: var(--text-mid);
    display: flex;
    align-items: center;
    gap: 8px;
}

.aud-list li::before {
    content: '✓';
    color: var(--green);
    font-weight: 700;
    font-size: .75rem;
}

/* MISSION */
.mission {
    background: var(--green);
    padding: 80px 7%;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.mission::before {
    content: '';
    position: absolute;
    top: -60px;
    right: -60px;
    width: 300px;
    height: 300px;
    background: rgba(255, 255, 255, .05);
    border-radius: 50%;
}

.mission-label {
    font-size: .7rem;
    font-weight: 700;
    letter-spacing: .15em;
    text-transform: uppercase;
    color: var(--pink-mid);
    margin-bottom: 16px;
}

.mission h2 {
    font-family: 'Lora', serif;
    font-size: clamp(1.7rem, 3vw, 2.6rem);
    font-weight: 400;
    color: white;
    line-height: 1.3;
    max-width: 680px;
    margin: 0 auto 18px;
}

.mission h2 em {
    font-style: italic;
    color: var(--pink);
}

.mission p {
    color: rgba(255, 255, 255, .68);
    font-size: .95rem;
    max-width: 520px;
    margin: 0 auto 34px;
    line-height: 1.75;
    font-weight: 300;
}

/* TESTIMONIALS */
.testimonials {
    padding: 90px 7%;
    background: var(--cream);
}

.testi-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 50px;
}

.testi-card {
    background: white;
    border-radius: 20px;
    padding: 28px;
    position: relative;
}

.testi-card::before {
    content: '"';
    position: absolute;
    top: 18px;
    right: 22px;
    font-family: 'Lora', serif;
    font-size: 4rem;
    color: var(--pink-light);
    line-height: 1;
}

.testi-stars {
    display: flex;
    gap: 2px;
    margin-bottom: 12px;
}

.star {
    color: var(--orange);
    font-size: .82rem;
}

.testi-text {
    font-size: .85rem;
    color: var(--text-mid);
    line-height: 1.75;
    margin-bottom: 18px;
    font-weight: 300;
    font-style: italic;
}

.testi-author {
    display: flex;
    align-items: center;
    gap: 11px;
}

.testi-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: var(--pink-mid);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .95rem;
}

.testi-name {
    font-weight: 700;
    font-size: .85rem;
    color: var(--text-dark);
}

.testi-role {
    font-size: .73rem;
    color: var(--text-light);
    font-weight: 300;
}

@keyframes fadeUp {
    from {
        opacity: 0;
        transform: translateY(22px)
    }

    to {
        opacity: 1;
        transform: translateY(0)
    }
}

.hero-content>* {
    animation: fadeUp .7s ease both;
}

.hero-content>*:nth-child(1) {
    animation-delay: .1s;
}

.hero-content>*:nth-child(2) {
    animation-delay: .22s;
}

.hero-content>*:nth-child(3) {
    animation-delay: .34s;
}

.hero-content>*:nth-child(4) {
    animation-delay: .46s;
}

/* RESPONSIVE */
.service-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

.cg-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
}

.audience-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
    margin-top: 50px;
}

.testi-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 50px;
}

.footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 48px;
    margin-bottom: 56px;
}

.why {
    padding: 90px 7%;
    background: var(--cream);
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 56px;
    align-items: center;
}

/* Tablet portrait + Mobile landscape */

/* Mobile portrait */

/* ════════════════════════════════
     RESPONSIVE
  ════════════════════════════════ */

/* Large tablet */

/* Tablet portrait & mobile landscape (≤768px)
     Layout: text on top | carousel below   side by side NOT possible */

/* Small mobile portrait (≤480px) */

/* ════════════ RESPONSIVE ════════════ */

/* Tablet portrait & mobile   text top, carousel below */

/* Small phones */

/* ══════════════════════════════════════
     RESPONSIVE
  ══════════════════════════════════════ */

/* ── Large tablet ≤1024px ── */

/* ── Tablet portrait & mobile ≤768px ── */

/* ── Small phones ≤480px ── */

/* ════════════ RESPONSIVE ════════════ */

/* Tablet portrait & mobile   text top, carousel below */

/* Small phones */

/* ════════════ RESPONSIVE ════════════ */

/* ══════════════════════════════════════
     RESPONSIVE BREAKPOINTS
  ══════════════════════════════════════ */

/* ── Large tablet ≤1024px ── */
@media (max-width: 1024px) {
    .service-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .cg-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .audience-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .testi-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .footer-grid {
        grid-template-columns: 2fr 1fr 1fr;
    }

    .why {
        gap: 32px;
    }
}

/* ── Mobile ≤768px ── */
@media (max-width: 768px) {

    /* Nav */
    .nav-links {
        display: none;
    }

    .nav-ctas .btn-ghost:first-child {
        display: none;
    }

    .ribbon {
        padding: 8px 14px;
        font-size: .78rem;
    }

    /* Hero   stack text then carousel */
    .hero {
        display: flex;
        flex-direction: column;
        min-height: auto;
        padding-top: 0;
        overflow: visible;
    }

    .hero::before {
        display: none;
    }

    .hero-content {
        order: 1;
        padding: 130px 6% 28px;
        background: var(--cream);
        position: relative;
        z-index: 2;
    }

    .hero h1 {
        font-size: clamp(1.8rem, 6.5vw, 2.5rem);
        line-height: 1.18;
        margin-bottom: 12px;
    }

    .hero-sub {
        font-size: .92rem;
        line-height: 1.7;
        max-width: 100%;
        margin-bottom: 22px;
    }

    .hero-ctas {
        gap: 10px;
    }

    .hero-ctas a {
        flex: 1;
        text-align: center;
        padding: 12px 14px;
        font-size: .85rem;
    }

    /* Carousel */
    .hero-visual {
        order: 2;
        display: block;
        position: relative;
        width: 100%;
        height: 480px;
        min-height: unset;
        overflow: hidden;
    }

    .hero-visual::after {
        display: none;
    }

    .carousel {
        width: 100%;
        height: 480px;
    }

    .carousel-slides {
        height: 480px;
    }

    .carousel-slide {
        height: 480px;
    }

    .carousel-slide img {
        width: 100%;
        height: 480px;
        object-fit: cover;
        object-position: center 12%;
    }

    .carousel-prev {
        left: 10px;
    }

    .carousel-next {
        right: 10px;
    }

    .carousel-dots {
        bottom: 14px;
    }

    /* Section padding reduction */
    .services {
        padding: 52px 6%;
    }

    .how {
        padding: 52px 6%;
    }

    .caregivers {
        padding: 52px 6%;
    }

    .audience {
        padding: 52px 6%;
    }

    .testimonials {
        padding: 52px 6%;
    }

    .mission {
        padding: 52px 6%;
    }

    footer {
        padding: 48px 6% 28px;
    }

    /* Section titles */
    .section-title {
        font-size: 1.4rem;
    }

    .section-sub {
        font-size: .88rem;
        margin-bottom: 28px;
    }

    /* care-header stacks on mobile */
    .care-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    /* Grids   single or 2-col */
    .service-grid {
        grid-template-columns: 1fr 1fr;
        gap: 14px;
    }

    .cg-grid {
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    .steps {
        grid-template-columns: 1fr;
    }

    .steps::before {
        display: none;
    }

    .why {
        grid-template-columns: 1fr;
        gap: 28px;
    }

    .why-visual {
        height: 280px;
    }

    .audience-grid {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .aud-card {
        padding: 26px 20px;
    }

    .testi-grid {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .footer-grid {
        grid-template-columns: 1fr;
        gap: 28px;
    }

    /* Caregiver card buttons */
    .cg-btn-request,
    .cg-btn-details {
        font-size: .74rem;
        padding: 9px 6px;
    }
}

/* ── Small phones ≤480px ── */
@media (max-width: 480px) {

    /* Hero */
    .hero-content {
        padding-top: 150px;
        padding-left: 5%;
        padding-right: 5%;
    }

    .hero h1 {
        font-size: 1.6rem;
        line-height: 1.2;
    }

    .hero-sub {
        font-size: .86rem;
    }

    .hero-ctas {
        flex-direction: column;
    }

    .hero-ctas a {
        width: 100%;
        text-align: center;
        font-size: .84rem;
        padding: 13px 16px;
        box-sizing: border-box;
    }

    /* Carousel */
    .hero-visual {
        height: 380px;
    }

    .carousel {
        height: 380px;
    }

    .carousel-slides {
        height: 380px;
    }

    .carousel-slide {
        height: 380px;
    }

    .carousel-slide img {
        height: 380px;
        object-fit: cover;
        object-position: center 12%;
    }

    /* Section padding */
    .services {
        padding: 40px 5%;
    }

    .how {
        padding: 40px 5%;
    }

    .caregivers {
        padding: 40px 5%;
    }

    .audience {
        padding: 40px 5%;
    }

    .testimonials {
        padding: 40px 5%;
    }

    .mission {
        padding: 40px 5%;
    }

    footer {
        padding: 36px 5% 24px;
    }

    /* Titles */
    .section-title {
        font-size: 1.25rem;
    }

    .section-sub {
        font-size: .84rem;
    }

    /* Grids */
    .service-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .cg-grid {
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }

    .audience-grid {
        grid-template-columns: 1fr;
    }

    .footer-grid {
        grid-template-columns: 1fr;
    }

    /* Cards */
    .aud-card {
        padding: 22px 16px;
    }

    .testi-card {
        padding: 20px 18px;
    }

    .cg-photo {
        height: 160px;
    }

    .cg-name {
        font-size: .88rem;
    }

    .cg-role {
        font-size: .74rem;
    }

    .cg-btn-request,
    .cg-btn-details {
        font-size: .72rem;
        padding: 8px 4px;
        border-radius: 8px;
    }
}


/* ── CONTACT PAGE STYLES ── */
.contact-hero {
    padding: 140px 7% 60px;
    background: var(--cream);
    text-align: center;
}

.contact-hero h1 span {
    color: var(--green);
    font-style: italic;
}

.contact-body {
    padding: 60px 7% 90px;
    background: white;
    display: grid;
    grid-template-columns: 1fr;
    gap: 0;
    max-width: 680px;
    margin: 0 auto;
    align-items: start;
}

/* LEFT   info cards */
.contact-info {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.info-card {
    background: var(--cream);
    border-radius: 18px;
    padding: 24px 22px;
    display: flex;
    align-items: flex-start;
    gap: 16px;
    border-left: 3px solid var(--pink);
    transition: border-color .2s, box-shadow .2s;
}

.info-card:hover {
    border-color: var(--green);
    box-shadow: 0 4px 16px rgba(23, 134, 95, .08);
}

.info-icon {
    width: 42px;
    height: 42px;
    background: var(--green-light);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
}

.info-card h4 {
    font-size: .85rem;
    font-weight: 700;
    color: var(--text-dark);
    margin-bottom: 4px;
}

.info-card p,
.info-card a {
    font-size: .82rem;
    color: var(--text-mid);
    line-height: 1.6;
    font-weight: 300;
    text-decoration: none;
}

.info-card a:hover {
    color: var(--green);
}








/* RIGHT   form */
.contact-form-wrap {
    background: var(--cream);
    border-radius: 24px;
    padding: 40px 36px;
}

.contact-form-wrap h3 {
    font-family: 'Lora', serif;
    font-size: 1.4rem;
    font-weight: 400;
    color: var(--text-dark);
    margin-bottom: 6px;
}

.contact-form-wrap p {
    font-size: .84rem;
    color: var(--text-mid);
    font-weight: 300;
    margin-bottom: 28px;
    line-height: 1.6;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 18px;
}

.form-group label {
    font-size: .76rem;
    font-weight: 700;
    color: var(--text-mid);
    letter-spacing: .06em;
    text-transform: uppercase;
}

.form-group input,
.form-group select,
.form-group textarea {
    font-family: 'Open Sans', sans-serif;
    font-size: .88rem;
    color: var(--text-dark);
    background: white;
    border: 1.5px solid rgba(245, 156, 171, .3);
    border-radius: 10px;
    padding: 12px 14px;
    outline: none;
    transition: border-color .2s, box-shadow .2s;
    width: 100%;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
    border-color: var(--green);
    box-shadow: 0 0 0 3px rgba(23, 134, 95, .08);
}

.form-group select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='%238A9E98'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 14px center;
    padding-right: 36px;
}

.form-group textarea {
    min-height: 110px;
    resize: vertical;
}

.required {
    color: var(--pink);
    margin-left: 2px;
}

.form-note {
    font-size: .76rem;
    color: var(--text-light);
    margin-bottom: 22px;
    font-weight: 300;
}

.btn-submit {
    width: 100%;
    background: var(--green);
    color: white;
    border: none;
    padding: 14px;
    border-radius: 100px;
    font-family: 'Open Sans', sans-serif;
    font-size: .92rem;
    font-weight: 700;
    cursor: pointer;
    transition: background .2s, transform .15s;
}

.btn-submit:hover {
    background: var(--green-dark);
    transform: translateY(-1px);
}

/* Success state */
.form-success {
    display: none;
    text-align: center;
    padding: 40px 20px;
}

.form-success .success-icon {
    width: 64px;
    height: 64px;
    background: var(--green-light);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    margin: 0 auto 16px;
}

.form-success h4 {
    font-family: 'Lora', serif;
    font-size: 1.3rem;
    font-weight: 400;
    color: var(--text-dark);
    margin-bottom: 8px;
}

.form-success p {
    font-size: .85rem;
    color: var(--text-mid);
    font-weight: 300;
}

/* Map strip */





.map-placeholder span {
    font-size: 2.5rem;
}

/* Responsive */
@media(max-width:1024px) {
    .contact-body {
        grid-template-columns: 1fr;
    }

}

@media(max-width:768px) {
    .nav-links {
        display: none;
    }

    .form-row {
        grid-template-columns: 1fr;
    }

    .contact-form-wrap {
        padding: 28px 20px;
    }
}

@media(max-width:480px) {
    .contact-hero {
        padding: 120px 5% 40px;
    }

    .contact-body {
        padding: 40px 5% 60px;
    }

    .nav-ctas .btn-ghost:first-child {
        display: none;
    }
}
</style>